module.exports = __webpack_public_path__ + "Icon_Non Field Activities Type.2cef353eddaf3b97fb50.png";